<div class="default-urgency-container" *ngIf="!isLoadingAvailableCustomer">
	<div class="container">
		<span class="tip">* {{ labels.lbl_nao_necessario_preencher_todos_campos_busca }}</span>
		<div class="dotted-input-container">
			<span>{{ labels.lbl_geral_cliente }}</span>
			<cpi-input-with-autocomplete
				[availableOptions]="availableCustomersIAC"
				[setValue]="selectedCustomer.value"
				[setInputText]="selectedCustomer.name"
				[minInputLength]="0"
				(onValueChange)="selectedCustomer.value = $event"
				(getInputText)="selectedCustomer.name = $event">
			</cpi-input-with-autocomplete>
		</div>
		<pcp-request-classification-reverse-rmk
			[hideField]="classificationOptions.hideField"
			[alertField]="classificationOptions.alertField"
			[idCustomerList]="selectedCustomer.value"
			(getClassification)="setSearchClassification($event)"
			(isLoadingClassification)="isLoadingClassification = $event"
			*ngIf="selectedCustomer?.value && selectedCustomer?.value !== ''">
		</pcp-request-classification-reverse-rmk>

		<div class="button-container">
			<div class="button" [ngClass]="{ disabled: isSearching || isLoadingClassification }" (click)="search()">
				{{ labels.lbl_geral_pesquisar }}
				<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isSearching"></cpi-dot-bounce-loading-effect>
			</div>
		</div>
	</div>

	<div class="container" *ngIf="classificationArr.length > 0">
		<div class="line header">
			<span>{{ labels.lbl_geral_competencia }}</span>
			<span>{{ labels.lbl_geral_natureza }}</span>
			<span>{{ labels.lbl_geral_topico }}</span>
			<span>{{ labels.lbl_urgencia_padrao }}</span>
		</div>
		<div class="line" *ngFor="let classification of classificationArr">
			<span [title]="classification.scope">{{ classification.scope }}</span>
			<span [title]="classification.category">{{ classification.category }}</span>
			<span [title]="classification.topic">{{ classification.topic }}</span>
			<span>
				<select (change)="classification.defaultUrgency = $event.target.value">
					<option [value]="'N/A'" [selected]="classification.defaultUrgency === 'N/A'">N/A</option>
					<option
						[value]="urgency.id"
						[selected]="classification.defaultUrgency == urgency.id"
						*ngFor="let urgency of availableUrgencies">
						{{ labels[urgency.label] ? labels[urgency.label] : urgency.label }}
					</option>
				</select>
			</span>
		</div>

		<div class="button-container">
			<div class="button" [ngClass]="{ disabled: isSaving || isLoadingClassification }" (click)="saveDefaultUrgency()">
				{{ labels.lbl_geral_salvar }}
				<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isSaving"></cpi-dot-bounce-loading-effect>
			</div>
		</div>
	</div>
</div>

<cpi-dot-bounce-loading-effect [color]="'var(--primary-color-1)'" *ngIf="isLoadingAvailableCustomer"></cpi-dot-bounce-loading-effect>
